<template>
  <sui-segment attached="bottom">
    <sui-table size="large" celled>
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell>Members</sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body v-show="members.length">
        <sui-table-row :class="{positive: member.id === m.id}" v-for="m in members" :key="m.id">
          <sui-table-cell>
            <div class="entity">
              <Logo class="entity-logo" :src="m.avatar" :email="m.email" square />
              <div class="entity-info">
                <b>{{m.name}}<small v-show="!m.confirmed"> (not confirmed)</small></b>
                <small v-if="!m.isOwner"><br>{{rolesById[m.role] ? rolesById[m.role].name : 'Without role'}}</small>
              </div>
              <small class="entity-limits" v-if="m.expiration">
                access until<br>
                <time>{{momentCalendar(m.expiration)}}</time>
              </small>
              <sui-button class="entity-button" size="tiny" icon="cog" color="blue" :disabled="m.isOwner" data-goal="ACCOUNT_MEMBERS_EDIT" basic @click.prevent="$modals.updateMember.open(m)" />
            </div>
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
      <sui-table-footer>
        <sui-table-row>
          <sui-table-header-cell>
            <sui-button color="green" size="small" icon="plus" label-position="left" :disabled="!access.accManagement || !account.limits.invite" data-goal="ACCOUNT_MEMBERS_ADD" @click.prevent="$modals.createMember.open()">Invite member</sui-button>
          </sui-table-header-cell>
        </sui-table-row>
      </sui-table-footer>
    </sui-table>
    <sui-message error v-if="apiErrors">
      {{apiErrors}}
    </sui-message>
  </sui-segment>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'AccountMembersView',
    data() {
      return {
        apiErrors: null,
      }
    },
    computed: {
      ...mapGetters(['access', 'account', 'member', 'members', 'rolesById']),
    },
  }
</script>

<style scoped>
  small { font-size: .8em; color: #999; }
  .entity { display: flex; align-items: center; }
  .entity-button { margin: 0 0 0 .5em!important; }
  .entity-icon { font-size: 1.8em; vertical-align: middle; margin-right: .5em; }
  .entity-info { flex: 1; }
  .entity-limits { float: right; text-align: right; line-height: 1.2; }
  .entity-logo { margin-right: .5em; height: 2em!important; width: 2em!important; border-radius: .2em; }
</style>
